(() => {
  if (window.__mobaiCartAddInstalled || typeof window.fetch !== 'function') return;
  window.__mobaiCartAddInstalled = true;
  const pending = new WeakSet();
  let text;
  try { text = JSON.parse(document.getElementById('mobai-cart-add-copy')?.textContent || '{}'); } catch { text = {}; }
  const defaults = {adding:'Adding to cart…',added:'Added. Opening your cart…',slow:'Confirming the result. Please do not submit again.',failed:'Could not add this item. Please try again shortly.',unknown:'We could not confirm the result. Check your cart before trying again.',cart:'View cart'};
  text = {...defaults,...text};
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form?.getAttribute?.('id') !== 'mobai-product-form' || event.defaultPrevented) return;
    const action = new URL(form.action, location.origin);
    const cart = new URL(form.getAttribute('data-mobai-cart-url') || '/cart', location.origin);
    if (action.origin !== location.origin || cart.origin !== location.origin ||
        !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/add\/?$/i.test(action.pathname)) return;
    if (!form.checkValidity()) return;
    event.preventDefault();
    if (pending.has(form)) return;
    pending.add(form);
    form.dataset.cartAddPending = 'true';
    // Let Shopify's existing fetch listener emit the standard cart event.
    // This asset does not install or send a second GA4 ecommerce event.
    const body = new FormData(form);
    const buttons = [...document.querySelectorAll('[data-add-button],[data-mobile-buybar-button]')]
      .filter(button => button.form === form);
    const previous = buttons.map(button => ({button, label:button.textContent, disabled:button.disabled}));
    previous.forEach(({button}) => { button.disabled = true; button.textContent = text.adding; });
    let status = form.querySelector('[data-cart-add-status]');
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-cart-add-status', '');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.append(status);
    }
    const message = (value, withCart = false) => {
      status.textContent = value;
      if (withCart) {
        const link = document.createElement('a');
        link.href = cart.href; link.textContent = text.cart;
        status.append(document.createTextNode(' '), link);
      }
    };
    const restore = () => {
      pending.delete(form);
      delete form.dataset.cartAddPending;
      previous.forEach(({button,label,disabled}) => { button.disabled = disabled; button.textContent = label; });
    };
    message(text.adding);
    const slow = setTimeout(() => message(text.slow, true), 15000);
    try {
      const response = await window.fetch(action.origin + action.pathname.replace(/\/$/, '') + '.js', {
        method: 'POST', credentials: 'same-origin', headers: {'Accept': 'application/json'}, body
      });
      clearTimeout(slow);
      if (!response.ok) {
        // Only a definite refusal can be retried here. A server/network failure
        // may have committed the cart change already; never repost automatically.
        if (response.status >= 400 && response.status < 500) {
          let detail;
          try { detail = await response.json(); } catch {}
          message(typeof detail?.description === 'string' ? detail.description : text.failed);
          restore();
        } else message(text.unknown, true);
        return;
      }
      await response.json();
      message(text.added);
      setTimeout(() => location.assign(cart.href), 350);
    } catch {
      clearTimeout(slow);
      message(text.unknown, true);
    }
  });
})();
